import dayjs from 'dayjs';

// Mismo criterio de "no repetir la fecha si el pase dura un solo día, sí mostrar
// la fecha de fin si dura varios" que ya resolvieron formatValidity
// (code/web/src/lib/pass/time.ts) y validityLabel (visitor-pass-creation.controller.ts,
// este repo) para otras pantallas. No se comparte código entre repos; esta es la
// versión propia del chip de vigencia de recepción.
export const formatValidity = (validFrom?: string, validUntil?: string): string => {
    if (!validFrom || !validUntil) {
        return '';
    }
    const from = dayjs(validFrom);
    const to = dayjs(validUntil);
    return from.isSame(to, 'day')
        ? `${from.format('DD/MM HH:mm')} a ${to.format('HH:mm')}`
        : `${from.format('DD/MM HH:mm')} a ${to.format('DD/MM HH:mm')}`;
};
